import UserManager from './UserManager';
import Culture from './Culture';
var CordovaHelpers = /** @class */ (function () {
    /**
     * Class constructor
     * @returns {void}
     */
    function CordovaHelpers() {
        /**Check if it is running native */
        this.IsCordova = false;
        /**Is running unser electron */
        this.IsElectron = false;
        /**Check if OS supports native browser */
        this.IsNativeBrowserAvailable = false;
        /**If true prevents the app from locking on pause */
        this._PreventLock = null;
        /**Store in app browser window reference */
        this.InAppBrowserWindow = null;
        /**If true it will force the app to lock */
        this.ForceLockOnResume = false;
        this.Initialize();
    }
    Object.defineProperty(CordovaHelpers.prototype, "PreventLock", {
        get: function () {
            return this._PreventLock;
        },
        set: function (preventLock) {
            this._PreventLock = preventLock;
            if (preventLock) {
                this.PreventLockDate = Culture.GetMoment();
            }
            else {
                if (this.PreventLockDate.add(15, 'minute').diff(Culture.GetMoment(), 'second') <= 0) {
                    this.ForceLockOnResume = true;
                }
                this.PreventLockDate = null;
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Class initializer
     */
    CordovaHelpers.prototype.Initialize = function () {
        var that = this;
        this.IsCordova = !(window.location.origin.indexOf('http://') > -1 || window.location.origin.indexOf('https://') > -1);
        if (this.IsCordova && navigator.userAgent.toLowerCase().indexOf('electron') > -1) {
            this.IsElectron = true;
        }
        if (this.IsCordova) {
            this.AddEventListeners();
            window["cordova"].plugins.browsertab.isAvailable(function (result) {
                that.IsNativeBrowserAvailable = result;
            }, function (_isAvailableError) {
                that.IsNativeBrowserAvailable = false;
            });
        }
    };
    /**
     * Add event listerns fro cordova events
     **/
    CordovaHelpers.prototype.AddEventListeners = function () {
        document.addEventListener('pause', this.CordovaOnPause, false);
        document.addEventListener('resume', this.CordovaOnResume, false);
    };
    /**Handle cordova on pause event (lock app) */
    CordovaHelpers.prototype.CordovaOnPause = function () {
        CordovaUtils.PreventLock = true;
    };
    /**Handle cordova on resume event (lock app) */
    CordovaHelpers.prototype.CordovaOnResume = function () {
        CordovaUtils.PreventLock = false;
        if (CordovaUtils.ForceLockOnResume) {
            CordovaUtils.ForceLockOnResume = false;
            UserManager.LockApp();
        }
    };
    /**Open browser window outside app */
    CordovaHelpers.prototype.OpenSystemBrowser = function (url, native) {
        if (native === void 0) { native = false; }
        if (!native || !this.IsNativeBrowserAvailable) {
            this.InAppBrowserWindow = window["cordova"].InAppBrowser.open(url, '_system', 'location=yes');
        }
        else {
            window["cordova"].plugins.browsertab.openUrl(url, function (_successResp) { return; }, function (_failureResp) {
                window["cordova"].InAppBrowser.open(url, '_system', 'location=yes');
            });
        }
    };
    /**Close browser window */
    CordovaHelpers.prototype.CloseSystemBrowser = function () {
        if (!this.IsNativeBrowserAvailable) {
            this.InAppBrowserWindow.close();
            this.InAppBrowserWindow = null;
        }
    };
    return CordovaHelpers;
}());
;
var CordovaUtils = new CordovaHelpers();
export default CordovaUtils;
//# sourceMappingURL=Cordova.js.map